import './BmiCalculator.css'
import { useState } from 'react';
import Axios from 'axios';
import { useAuth } from "../Context/AuthContext";

function BmiCalculator() { 
    const [heightValue, setHeightValue] = useState(''); 
    const [weightValue, setWeightValue] = useState(''); 
    const [bmiValue, setBmiValue] = useState(''); 
    const [bmiMessage, setBmiMessage] = useState(''); 
    let [messageColor, setMessageColor] = useState('');
    const { appUser, setUser, isLogin, setLogin } = useAuth();
    
    const calculateBmi = async () => { 
        if (heightValue && weightValue) { 
            const heightInMeters = heightValue / 100; 
            const bmi = (weightValue / (heightInMeters * heightInMeters)).toFixed(2); 
            setBmiValue(bmi); 
            try{
                const response=await Axios.post('https://fitness-junction-bots.onrender.com/api/saveftdata',{'userEmail':appUser.email,'toolName':'BMI','toolValue':bmi});
                console.log(response);
            }catch(error){
                console.log(error);
            }
            let message = ''; 
            if (bmi < 18.5) { 
                message = 'Under Weight';           
                setMessageColor('#979c01');
            } else if (bmi >= 18.5 && bmi < 25) { 
                message = 'Normal Weight'; 
                setMessageColor('green');
            } else if (bmi >= 25 && bmi < 30) { 
                message = 'Over Weight'; 
                setMessageColor( 'orange');
            } else { 
                message = 'Obesity'; 
                setMessageColor('Red');

                //change CSS of Message also
            } 
            setBmiMessage(message); 
        } else { 
            setBmiValue(''); 
            setMessageColor('black'); 
            
        } 
        console.log(messageColor);
    }; 
  
    return ( 
        
        <div className="bmi-container"> 
            <div className="input-container"> 
                <label htmlFor="height">Enter Your Height (cm):</label> 
                <input 
                    type="number"
                    id="height"
                    value={heightValue} 
                    onChange={(e) => setHeightValue(e.target.value)} 
                /> 
            </div> 
            <div className="input-container"> 
                <label htmlFor="weight">Enter Your Weight (kg):</label> 
                <input 
                    type="number"
                    id="weight"
                    value={weightValue} 
                    onChange={(e) => setWeightValue(e.target.value)} 
                /> 
            </div> 
            <button className="calculate-btn" onClick={calculateBmi}> 
                Calculate BMI 
            </button> 
            {bmiValue && bmiMessage && ( 
                <div className="result"> 
                    <p> 
                        BMI: <span className="bmi-value">{bmiValue}</span> 
                    </p> 
                    <p> 
                        <span className="bmi-message" 
                        style={{
                            color:messageColor,
                            fontWeight:"bolder",
                            }}
                        >{bmiMessage}</span> 
                    </p> 
                </div> 
            )} 
        </div> 
        
    ); 
} 
  
export default BmiCalculator;
